// extracted by mini-css-extract-plugin
export default {"tabs":"DialerTabs_tabs__cc5ZV","tab":"DialerTabs_tab__idGOX","active":"DialerTabs_active__2j77r"};